export default __webpack_public_path__ + "static/media/wipro.4b022dbb.png";